import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as supplierAction from './../../../../actions/supplierAction';
import Suppliers from './Suppliers';

const mapStateToProps = state => {
    return {
        supplierState: state.supplierReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSuppliers: (params) => dispatch(supplierAction.getSupplierList(params)),
        deleteSupplier: (supplier, refreshParams) => dispatch(supplierAction.deleteSupplierAction(supplier, refreshParams)),
        getSupplierProducts: (params) => dispatch(supplierAction.getSupplierProducts(params)),
        deleteSupplierProduct: (supplierProduct) => dispatch(supplierAction.deleteSupplierProductAction(supplierProduct)),
        getSupplierAll: () => dispatch(supplierAction.getSupplierListAll()),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Suppliers));
